import { render, staticRenderFns } from "./SPopup.vue?vue&type=template&id=34323fa3&scoped=true&"
import script from "./SPopup.vue?vue&type=script&lang=ts&"
export * from "./SPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SPopup.vue?vue&type=style&index=0&id=34323fa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34323fa3",
  null
  
)

export default component.exports